import { render, staticRenderFns } from "./StaffHarm.vue?vue&type=template&id=99fa19f0&scoped=true"
import script from "./StaffHarm.vue?vue&type=script&lang=js"
export * from "./StaffHarm.vue?vue&type=script&lang=js"
import style0 from "./StaffHarm.vue?vue&type=style&index=0&id=99fa19f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fa19f0",
  null
  
)

export default component.exports